module.exports = __webpack_public_path__ + "img/tool.b6ebc6aa.svg";